import _ from 'lodash'
import customizer from './customizer'

export default (obj, ...sources) => (
  _.mergeWith(obj, ...sources, customizer)
)
